import { useMemo } from "react";

import { InvoiceViewer } from "@/components/shared/invoice-review/invoice-viewer";
import InvoiceProvider from "@/features/invoice-standard-review/accounting/ReviewProvider";
import { useInvoicePdfCache } from "@/providers/invoice-pdf-cache";

type Props = {
  invoiceId: string;
  height?: number;
};

const InlineSimpleInvoiceViewer = ({ invoiceId, height }: Props) => {
  const { getPdfBlob } = useInvoicePdfCache();

  const pdfBlob = useMemo(() => {
    return getPdfBlob(invoiceId);
  }, [invoiceId, getPdfBlob]);

  return (
    <div className="h-full bg-gray-200">
      <div className={height ? undefined : "h-full"} style={{ height }}>
        <InvoiceProvider invoiceId={invoiceId}>
          <InvoiceViewer
            pdfBlob={pdfBlob ?? ""}
            invoiceId={invoiceId}
            canvasEnabled={false}
            coordinates={undefined}
          />
        </InvoiceProvider>
      </div>
    </div>
  );
};

export const SimpleInvoiceViewer = ({ invoiceId, height }: Partial<Props>) => {
  if (!invoiceId) {
    return null;
  }

  return (
    <InlineSimpleInvoiceViewer
      key={invoiceId}
      invoiceId={invoiceId}
      height={height}
    />
  );
};
